import { CURRENCY_OPTIONS } from './countryDefaults';

export const PARTNER_PLAN_BILLING_INTERVALS = [
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'yearly', label: 'Yearly' },
] as const;

export type PartnerPlanBillingInterval = typeof PARTNER_PLAN_BILLING_INTERVALS[number]['value'];

export const PARTNER_PLAN_TYPE_OPTIONS = [
  { value: 'driver', label: 'Driver' },
  { value: 'delivery_partner', label: 'Delivery partner' },
  { value: 'merchant', label: 'Restaurant / Merchant' },
  { value: 'service_provider', label: 'Service provider' },
  { value: 'all', label: 'All partner types' },
] as const;

/** Partner types available in the add-plan multi-select (excludes "all"). */
export const PARTNER_PLAN_SELECTABLE_TYPES = PARTNER_PLAN_TYPE_OPTIONS.filter((o) => o.value !== 'all');

export type PartnerPlanType = typeof PARTNER_PLAN_TYPE_OPTIONS[number]['value'];

export const PARTNER_PLAN_CURRENCY_OPTIONS = CURRENCY_OPTIONS;

/** Max allowed plan price (inclusive). 0 = free / custom. */
export const PARTNER_PLAN_PRICE_MIN = 0;
export const PARTNER_PLAN_PRICE_MAX = 999_999;

export const PARTNER_PLAN_VALIDITY_DAYS_MIN = 1;
export const PARTNER_PLAN_VALIDITY_DAYS_MAX = 365;

/** 0 = no free trial. */
export const PARTNER_PLAN_TRIAL_DAYS_MIN = 0;
export const PARTNER_PLAN_TRIAL_DAYS_MAX = 365;

export const PARTNER_PLAN_GRACE_PERIOD_MIN = 0;
export const PARTNER_PLAN_GRACE_PERIOD_MAX = 90;

/** Leave max rides blank for unlimited. */
export const PARTNER_PLAN_MAX_RIDES_MIN = 1;
export const PARTNER_PLAN_MAX_RIDES_MAX = 99_999;

export const PARTNER_PLAN_FORM_TABS = [
  { id: 'info', title: 'Plan info', subtitle: 'Code, zone, and partner type' },
  { id: 'pricing', title: 'Pricing & rules', subtitle: 'Price, billing cycle, validity, and ride limits' },
  { id: 'benefits', title: 'Benefits & publish', subtitle: 'Commission rules, features, badges, and visibility' },
] as const;

export type PartnerPlanFormTabId = typeof PARTNER_PLAN_FORM_TABS[number]['id'];

export const PARTNER_PLAN_FEATURE_SUGGESTIONS = [
  'No commission on rides',
  'Priority dispatch',
  'Auto-renew',
  'Weekly settlement',
  'Dedicated support',
];

export const VALIDITY_BY_INTERVAL: Record<PartnerPlanBillingInterval, number> = {
  daily: 1,
  weekly: 7,
  monthly: 30,
  yearly: 365,
};

/** Instructional notes and helper copy — darker than default text.secondary for readability. */
export const PARTNER_PLAN_NOTE_SX = {
  color: 'text.primary',
  opacity: 0.9,
  lineHeight: 1.55,
  fontWeight: 500,
} as const;

export const PARTNER_PLAN_ALERT_SX = {
  borderRadius: 2,
  '& .MuiAlert-message': {
    color: 'text.primary',
    fontWeight: 500,
    lineHeight: 1.55,
  },
} as const;

export const PARTNER_PLAN_FORM_HELPER_SX = {
  '& .MuiFormHelperText-root:not(.Mui-error)': {
    color: 'text.primary',
    opacity: 0.85,
    fontWeight: 500,
  },
} as const;
